import { render } from "./Th.vue?vue&type=template&id=68d1155e"
import script from "./Th.vue?vue&type=script&lang=js"
export * from "./Th.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__